import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../user.service';
import { ActionService } from '../../core/action.service';
import { AlertsService } from '../../core/alerts.service';
import { DialogService } from '../../core/dialog.service';
import { EventsService } from '../../core/event.service';
import { LocalStorageService } from '../../core/local-storage.service';
import { OverlayService } from '../../core/overlay.service';
import { ListBase } from '../../base/list/list.base';
import { ForecastService } from '../forecast.service';
var ForecastListComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ForecastListComponent, _super);
    /**
     * Creates an instance of ForecastListComponent.
     * @param {UserService} userService
     * @param {ForecastService} forecastService
     * @param {DialogService} dialogService
     * @param {AlertsService} alertsService
     * @param {TranslateService} translateService
     * @param {Router} router
     * @param {OverlayService} overlayService
     * @param {LocalStorageService} localStorageService
     * @param {EventsService} eventsService
     * @param {ActionService} actionService
     * @memberOf ForecastListComponent
     */
    function ForecastListComponent(userService, forecastService, dialogService, alertsService, translateService, router, overlayService, localStorageService, eventsService, actionService) {
        return _super.call(this, userService, forecastService, dialogService, alertsService, translateService, router, overlayService, localStorageService, eventsService, actionService) || this;
    }
    /**
     * Overrides to refresh the list immediately.
     * @returns {Promise<QueryResult>} The query results.
     * @memberOf ForecastListComponent
     */
    ForecastListComponent.prototype.refresh = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _super.prototype.refresh.call(this)];
                    case 1:
                        result = _a.sent();
                        this.items = this.items;
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * Overrides to make the whole list unsortable.
     * @param {FieldConfiguration} field The parameter is not used.
     * @returns {boolean} false.
     * @memberOf ForecastListComponent
     */
    ForecastListComponent.prototype.isSortable = function (field) {
        return false;
    };
    return ForecastListComponent;
}(ListBase));
export { ForecastListComponent };
